import { useEffect, useRef } from "react";

export default function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef<() => void>();

  // 최신 콜백을 ref에 저장
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null) return;

    const tick = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };

    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}
